import { get, del, post, put } from "../utils/axios/axios.config";
import * as url from "./url-helper";
// import { AUTH_CONFIG } from "../services/authServices/token.config";

// ------------------------ Fetch users by plant ID (New) -------------------------
const getAllUsersByPlantIdWithoutSuperAdmin = (Payload) =>
  // get(`${url.GET_ALL_USER_BY_PLANT_ID_WITHOUT_SUPER_ADMIN}/${plantId}/account/${accountId}`)
  post(url.GET_ALL_USER_BY_PLANT_ID_WITHOUT_SUPER_ADMIN, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// API to get all the user of perticular account
const getAllUsersByAccountId = (AccountId) =>
  get(`${url.GET_ALL_USER_BY_ACCOUNT_ID}/${AccountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// ---------------------- Role Master API --------------------------
// Get all roles - Data Table
const getAllRoles = (accountId) =>
  get(`${url.GET_ALL_ROLE}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get Role by Id
const getRoleById = (id, accountId) =>
  get(`${url.GET_ROLE_BY_ID}/${id}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create role and assign responsibility
const createRole = (data) =>
  post(url.CREATE_ROLE, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update role
const updateRole = (data) =>
  put(url.UPDATE_ROLE, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete Role
const deleteRole = (id, accountId) =>
  del(`${url.DELETE_ROLE}/${id}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// -------------------- Responsibility/screen-access API ------------------------
// Get all responsibility or screen-access
const getAllResponsibility = () =>
  get(url.GET_ALL_RESPONSIBILITY)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });



//------------------------------ Plant Master CRUD ------------------------------
// Get all plants - Data Table
const getAllBranches = (accountId) =>
  get(`${url.GET_ALL_PLANT}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create Plant
const createBranch = (data) =>
  post(url.CREATE_PLANT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update Plant
const updateBranch = (data) =>
  put(url.UPDATE_PLANT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete Plant
const deleteBranch = (branchId, accountId) =>
  del(`${url.DELETE_PLANT}/${branchId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });    


//------------------------------ Area Master CRUD ------------------------------
// Get all the areas
const getAllAreas = (accountId) =>
  get(`${url.GET_All_AREAS}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get all the areas acc. to branch & dept
const getAreasByBranchAndDept = (Payload) =>
  // get(`${url.GET_AREA_BY_BRANCH_AND_DEPT}/account/${accountId}/branch/${branchId}/department/${departmentId}`)
  post(url.GET_AREA_BY_BRANCH_AND_DEPT, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create Area
const createArea = (data) =>
  post(url.CREATE_AREA, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update Area
const updateArea = (data) =>
  put(url.UPDATE_AREA, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete Area
const deleteArea = (areaId, accountId) =>
  del(`${url.DELETE_AREA}/${areaId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });    


//------------------------------ User Master CRUD ------------------------------
// Get User by it's ID
const getUserById = (id, accountId) =>
  get(`${url.GET_USER_BY_ID}/${id}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get all users by plant ID
const getAllUsersByPlantId = (data) =>
  post(url.GET_ALL_USER_BY_PLANT_ID, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create user
const createUser = (data) =>
  post(url.CREATE_USER, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update user
const updateUser = (data) =>
  put(url.UPDATE_USER, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete user
const deleteUser = (id) =>
  del(`${url.DELETE_USER}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });   


// ----------------------------- Activity Master CRUD --------------------------
// Get all of activity
const getAllActivityList = (accountId) =>
  get(`${url.GET_ALL_ACTIVITY}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create a new activity
const createActivity = (data) =>
  post(url.CREATE_ACTIVITY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing activity
const updateActivity = (data) =>
  put(url.UPDATE_ACTIVITY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete existing activity
const deleteActivity = (activityId, accountId) =>
  del(`${url.DELETE_ACTIVITY}/${activityId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Check list bulk upload
const createBulkCheckPoints = (data) =>
  post(url.CREATE_BULK_CHECKLIST, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });    


// ----------------------------- PPE Master CRUD --------------------------
// Get all PPE's list
const getAllPPEList = (accountId) =>
  get(`${url.GET_ALL_PPE}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create a new PPE
const createPPE = (data) =>
  post(url.CREATE_PPE, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing PPE details
const updatePPE = (data) =>
  put(url.UPDATE_PPE, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete existing PPE
const deletePPE = (id, accountId) =>
  del(`${url.DELETE_PPE}/${id}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });    


// ----------------------------- Holiday Master CRUD --------------------------
// Get all the list of holidays
const getAllHolidayList = (accountId) =>
  get(`${url.GET_All_HOLIDAYS}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get holiday's list as per plant (by plantId)
const getAllHolidayListByPlantId = (plantId, accountId) =>
  get(`${url.GET_All_HOLIDAYS_BY_PLANT_ID}/${plantId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new Holiday in a plant
const createHoliday = (data) =>
  post(url.CREATE_HOLIDAY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing Holiday in a plant
const updateHoliday = (data) =>
  put(url.UPDATE_HOLIDAY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete existing Holiday in a plant
const deleteHoliday = (holidayId, accountId) =>
  del(`${url.DELETE_HOLIDAY}/${holidayId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new Holiday in a plant
const createBulkHolidays = (data) =>
  post(url.CREATE_BULK_HOLIDAY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });    


// ----------------------------- Department Master CRUD --------------------------
// Get all the list of departments in branch
const getAllDepartmentList = (accountId) =>
  get(`${url.GET_All_DEPARTMENT}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get department list as per branch (by branchId)
const getAllDepartmentListByBranchId = (Payload) =>
  // get(`${url.GET_All_DEPARTMENT_BY_PLANT_ID}/${branchId}/account/${accountId}`)
  post(url.GET_All_DEPARTMENT_BY_PLANT_ID, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new department in a branch
const createDepartment = (data) =>
  post(url.CREATE_DEPARTMENT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing department in a branch
const updateDepartment = (data) =>
  put(url.UPDATE_DEPARTMENT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete existing department in a branch
const deleteDepartment = (data) =>
  del(url.DELETE_DEPARTMENT, {
    data: {
      ...data
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// ----------------------------- Contractor Master CRUD --------------------------
// Get all the list of contractor
const getAllContractorList = (accountId) =>
  get(`${url.GET_All_CONTRACTOR}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get contractor by it's id
const getContractorById = (contractorId, accountId) =>
  get(`${url.GET_CONTRACTOR_BY_ID}/${contractorId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new contractor
const createContractor = (data) =>
  post(url.CREATE_CONTRACTOR, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing contractor
const updateContractor = (data) =>
  put(url.UPDATE_CONTRACTOR, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete existing contractor
const deleteContractor = (contractorId, accountId) =>
  del(`${url.DELETE_CONTRACTOR}/${contractorId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// ----------------------------- Labour Master CRUD --------------------------
// Get all the list of labour
const getAllLabourList = (accountId) =>
  get(`${url.GET_All_LABOURS}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get labour by contractor id
const getAllLaboursByContractorId = (contractorId, accountId) =>
  get(`${url.GET_ALL_LABOURS_BY_CONTRACTOR_ID}/${contractorId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get contractor by it's id
const getLabourById = (labourId, accountId) =>
  get(`${url.GET_LABOUR_BY_ID}/${labourId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new labour
const createLabour = (data) =>
  post(url.CREATE_LABOUR, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing labour
const updateLabour = (data) =>
  put(url.UPDATE_LABOUR, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete existing labour
const deleteLabour = (labourId, accountId) =>
  del(`${url.DELETE_LABOUR}/${labourId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });    


// ----------------------------- Audit Type Master CRUD --------------------------
// Get all the list of audit type
const getListOfAuditType = (accountId) =>
  get(`${url.GET_ALL_AUDIT_TYPE}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new audit type
const createAuditType = (data) =>
  post(url.CREATE_AUDIT_TYPE, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing audit type
const updateAuditType = (data) =>
  put(url.UPDATE_AUDIT_TYPE, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });   

// Create new Holiday in a plant
const createAuditTypeWithBulkActivities = (data) =>
  post(url.UPDATE_AUDIT_TYPE_WITH_BULK_ACTIVITIES, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });   



// ----------------------------- Audit Master API's function ----------------------------
// Get all the list of audit type category
const getListOfAuditTypeCategories = (accountId) =>
  get(`${url.GET_ALL_AUDIT_TYPE_CATEGORY}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new audit type
const createAuditTypeCategory = (data) =>
  post(url.CREATE_AUDIT_TYPE_CATEGORY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing audit type
const updateAuditTypeCategory = (data) =>
  put(url.UPDATE_AUDIT_TYPE_CATEGORY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update existing audit type
const deleteAuditTypeCategory = (categoryId, accountId) =>
  del(`${url.DELETE_AUDIT_TYPE_CATEGORY}/${categoryId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// ----------------------------- Audit Master API's function ----------------------------
// Get all audits of branch
const getAllAudits = (Payload) =>
  // get(`${url.GET_ALL_AUDITS}/account/${AccountId}/branch/${BranchId}/department/${DepartmentId}/user/${UserId}`)
  post(url.GET_ALL_AUDITS, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create new audit
const createAudit = (data) =>
  post(url.CREATE_AUDIT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Edit existing audit (Admin and super-admin)
const editAuditForAdminAndSuperAdmin = (data) =>
  put(url.EDIT_AUDIT_FOR_ADMIN_SUPERADMIN, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Edit/Update/Review existing audit (Auditor)
const auditUpdatedByAuditor = (data) =>
  put(url.AUDIT_REVIEW_BY_AUDITOR, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Edit/Update/Review existing audit (Auditee)
const auditUpdatedByAuditee = (data) =>
  put(url.AUDIT_REVIEW_BY_AUDITEE, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Close existing audit (Auditee)
const closeAudit = (data) =>
  put(url.CLOSE_AUDIT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// ----------------------------- Reports for Audits --------------------------
    // Get all audits of branch
const generateAuditReport = (data) =>
  post(url.GENERATE_AUDIT_REPORT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

    // Get all audits of branch
const generateNCReport = (data) =>
  post(url.GENERATE_NC_REPORT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

    // Get all third party audits report
const generateThirdPartyAuditReport = (data) =>
  post(url.GENERATE_THIRD_PARTY_AUDIT_REPORT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// ----------------------------- Dashboard Data API's ------------------------
// Get Dashboard data of audit count status
const getDashboardDataOfAuditStatusCount = (Payload) =>
  // get(`${url.DASHBOARD_DATA}/branch/${BranchId}/department/${DepartmentId}/user/${UserId}/account/${AccountId}`)
  post(url.DASHBOARD_DATA, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });



// // ----------------------------- Work Permit (Regular & Holiday CRUD) --------------------------
// // Create new work permit
// const createWorkPermit = (data) =>
//   post(url.CREATE_WORK_PERMIT, data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });

// // Update existing work permit
// const updateWorkPermit = (data) =>
//   post(url.UPDATE_WORK_PERMIT, data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });

// // Get all work permit type by it's type and plant - For Super-Admin (Not Used)
// const getAllWorkPermitsByItsTypeAndPlant = (
//   PlantId,
//   WorkPermitTypeId,
//   accountId
// ) =>
//   get(
//     `${url.GET_ALL_WORK_PERMIT_BY_ITS_TYPE_AND_PLANT}/${PlantId}/workPermitType/${WorkPermitTypeId}/account/${accountId}`
//   )
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });

// // Get all work permit by it's type, plant and userId - For Normal User (Not Used)
// const getAllWorkPermitsByItsTypeAndPlantAndUser = (PlantId, WorkPermitTypeId, UserId, accountId) =>
//   get(
//     `${url.GET_ALL_WORK_PERMIT_BY_ITS_TYPE_AND_PLANT_AND_USER}/${PlantId}/workPermitType/${WorkPermitTypeId}/user/${UserId}/account/${accountId}`
//   )
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });

// // Get all work pemit by its status - (Currently In Used)
// const getAllWorkPermitByItsStatus = (Data) => 
//   post(url.GET_ALL_WORK_PERMIT_BY_ITS_STATUS, Data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });


// // Get all work permit by it's type and statusId
// const getAllWorkPermitsByItsTypeAndStatus = (PlantId, StatusId, accountId) =>
//   get(
//     `${url.GET_ALL_WORK_PERMIT_BY_ITS_PLANT_AND_STATUS}/${PlantId}/status/${StatusId}/account/${accountId}`
//   )
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     }); 

// // Get all work permit by it's id
// const getAllWorkPermitsByItsId = (WorkPermitId, accountId) =>
//   get(`${url.GET_WORK_PERMIT_BY_ITS_ID}/${WorkPermitId}/account/${accountId}`)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });

// // Approve or Reject work permit
// const approveOrRejectWorkPermit = (data) =>
//   post(url.APPROVE_OR_REJECT_WORK_PERMIT, data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });
    
// // Suspend work permit
// const suspendWorkPermit = (data) =>
//   post(url.SUSPEND_WORK_PERMIT, data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });    

// // Review and save work permit
// const reviewWorkPermit = (data) =>
//   post(url.REVIEW_WORK_PERMIT, data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });    

// // Close work permit
// const closeWorkPermit = (data) =>
//   post(url.CLOSE_WORK_PERMIT, data)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });

// // Delete work permit
// const deleteWorkPermit = (workPermitId, accountId) =>
//   del(`${url.DELETE_WORK_PERMIT}/${workPermitId}/account/${accountId}`)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error?.response;
//     });    


// ------------------------------ Work Permit Dashboard API's -------------------------------
// Get all work permit count by plant (Only for Super Admin)
const getAllWorkPermitCountByPlant = (PlantId, UserId, accountId) =>
  get(`${url.GET_ALL_WORK_PERMIT_COUNT_BY_SUPER_ADMIN}/${PlantId}/user/${UserId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
    
// Get all work permit count by plant and user id (Only for Normal User)
const getAllWorkPermitCountByPlantAndUserId = (PlantId, UserId, accountId) =>
  get(`${url.GET_ALL_WORK_PERMIT_COUNT_BY_USER_ID}/${PlantId}/user/${UserId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get all work permit types count
const getAllWorkPermitCountByItsTypeAndPlantId = (PlantId, UserId, accountId) =>
  get(`${url.GET_ALL_WORK_PERMIT_COUNT_BY_ITS_TYPE}/${PlantId}/user/${UserId}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get all modules count for work permit dashboard
const getAllModulesCountForDashboard = (accountId) =>
  get(`${url.GET_TOTAL_MODULES_COUNT_FOR_DASHBOARD}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// ------------------------------ Company Information API's -------------------------------
// Get all the information of company
const getCompanyInformation = (accountId) =>
  get(`${url.GET_COMPANY_DETAILS}/account/${accountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update all the information of company
const updateCompanyInformation = (Data) =>
  put(url.UPDATE_COMPANY_DETAILS, Data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// ------------------------------ Work Permit Report API -------------------------------
// Work Permit Detailed Report
const generateWorkPermitReport = (data) =>
  post(url.GET_WORK_PERMIT_REPORT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Work Permit Summary Report
const generateWorkPermitSummaryReport = (data) =>
  post(url.GET_WORK_PERMIT_SUMMARY_REPORT, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
    

// ------------------------------ Forgot Password API -------------------------------
// Forgot Password API
const sendForgotPasswordEmail = (data) =>
  post(url.FORGOT_PASSWORD, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// ------------------------------ Third Party Audit API's -------------------------------
// Get All Third Party Audits By Branch, Department
const getAllThirdPartyAudits = (Payload) =>
  post(url.GET_ALL_THIRD_PARTY_AUDITS, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Create Third Party Audit 
const createNewThirdPartyAudit = (Payload) =>
  post(url.CREATE_THIRD_PARTY_AUDIT, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update Third Party Audit 
const updateExistingThirdPartyAudit = (Payload) =>
  put(url.UPDATE_THIRD_PARTY_AUDIT, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update Status Of Party Audit to 'Completed'
const updateStatusOfThirdPartyAuditToCompleted = (Payload) =>
  put(url.UPDATE_STATUS_OF_THIRD_PARTY_AUDIT, Payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete Third Party Audit
const deleteThirdPartyAudit = (ThirdPartyAuditId, AccountId) =>
  del(`${url.UPDATE_STATUS_OF_THIRD_PARTY_AUDIT}/${ThirdPartyAuditId}/account/${AccountId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });



// ------------------------------- Zingworks API Functions ----------------------------------
// --------------------------------- Account Master API -------------------------------------
// Create New Account (Company)
const createNewCompanyAccount = (data) =>
  post(url.CREATE_NEW_COMPANY, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Update Existing Account (Company)
const updateExistingCompanyAccount = (data) =>
  post(url.UPDATE_COMPANY_INFORMATION, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get all companies information
const getAllCompaniesInfo = () =>
  get(url.GET_COMPANY_INFORMATION)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Delete exiting account/company
const deleteExistingCompanyAccount = (AccounId) =>
  del(`${url.DELETE_COMPANY_ACCOUNT}/${AccounId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });


// --------------------------------- Account Master API -------------------------------------
// Assign super-admin to existing Account/Company
const assignNewSuperAdminToExistingAccount = (data) =>
  post(url.ASSIGN_ANOTHER_SUPER_ADMIN, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });

// Get a account id to which the zingworks has assigned a temprary super-admin
const getAssignedSuperAdminForCompany = () =>
  get(url.GET_ASSIGNED_SUPER_ADMIN)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error?.response;
    });
    
    
export {
  // Fetch users by plant id (New)
  getAllUsersByPlantIdWithoutSuperAdmin,
  // To get all user of account
  getAllUsersByAccountId,

  // Related to Role Master
  getAllRoles,
  getRoleById,
  createRole,
  updateRole,
  deleteRole,

  // Related to responsibility 
  getAllResponsibility,

  // Related to Plant Master
  getAllBranches,
  createBranch,
  updateBranch,
  deleteBranch,

  // Related to Area Master
  getAllAreas,
  getAreasByBranchAndDept,
  createArea,
  updateArea,
  deleteArea,

  // Related to User Master
  getUserById,
  getAllUsersByPlantId,
  createUser,
  updateUser,
  deleteUser,

  // Related to Check List Master
  getAllActivityList,
  createActivity,
  updateActivity,
  deleteActivity,
  createBulkCheckPoints,

  // Releted to PPE Master
  getAllPPEList,
  createPPE,
  updatePPE,
  deletePPE,

  // Related to Holiday Master
  getAllHolidayList,
  getAllHolidayListByPlantId,
  createHoliday,
  updateHoliday,
  deleteHoliday,
  createBulkHolidays,

  // Related to Location Master
  getAllDepartmentList,
  getAllDepartmentListByBranchId,
  createDepartment,
  updateDepartment,
  deleteDepartment,

  // Related to Contractor Master
  getAllContractorList,
  getContractorById,
  createContractor,
  updateContractor,
  deleteContractor,

  // Related to Labour Master
  getAllLabourList,
  getAllLaboursByContractorId,
  getLabourById,
  createLabour,
  updateLabour,
  deleteLabour,

  // Related to Work Permit Type Master
  getListOfAuditType,
  createAuditType,
  updateAuditType,
  createAuditTypeWithBulkActivities,

  // Related to Audit Type Category
  getListOfAuditTypeCategories,
  createAuditTypeCategory,
  updateAuditTypeCategory,
  deleteAuditTypeCategory,

  // Related to work permit Master (CRUD)
  // createWorkPermit,
  // updateWorkPermit,
  // getAllWorkPermitsByItsTypeAndPlant,
  // getAllWorkPermitsByItsTypeAndPlantAndUser,
  // getAllWorkPermitsByItsTypeAndStatus,
  // getAllWorkPermitsByItsId,
  // approveOrRejectWorkPermit,
  // suspendWorkPermit,
  // reviewWorkPermit,
  // closeWorkPermit,
  // deleteWorkPermit,
  // getAllWorkPermitByItsStatus,

  // Realted to Audit Master CRUD
  getAllAudits,
  createAudit,
  editAuditForAdminAndSuperAdmin,
  auditUpdatedByAuditor,
  auditUpdatedByAuditee,
  closeAudit,

  // Related to Audit report
  generateAuditReport,
  generateNCReport,
  generateThirdPartyAuditReport,

  // Related to dashboard API
  getAllWorkPermitCountByPlant,
  getAllWorkPermitCountByPlantAndUserId,
  getAllWorkPermitCountByItsTypeAndPlantId,
  getAllModulesCountForDashboard,

  // Related to Company Information
  getCompanyInformation,
  updateCompanyInformation,

  // Related to Work Permit Report
  generateWorkPermitReport,
  generateWorkPermitSummaryReport,

  // Related to Forgot Password
  sendForgotPasswordEmail,

  // Dashboard Data of Audit Status count 
  getDashboardDataOfAuditStatusCount,

  // Related to Third Party Audit
  getAllThirdPartyAudits,
  createNewThirdPartyAudit,
  updateExistingThirdPartyAudit,
  updateStatusOfThirdPartyAuditToCompleted,
  deleteThirdPartyAudit,

  // --- Zingworks API Function ---
  // Account Master API
  createNewCompanyAccount,
  updateExistingCompanyAccount,
  getAllCompaniesInfo,
  deleteExistingCompanyAccount,

  // Assign Super Admin API
  assignNewSuperAdminToExistingAccount,
  getAssignedSuperAdminForCompany,
};
